import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { UserService } from 'src/app/shared-services/userservice.service';
@Component({
selector:'app-history',
templateUrl: "./history.component.html",
  styleUrls: ["./history.component.scss"]

})

export class HistoryComponent implements OnInit {
    gridApi;
    paginationPageSize;
    domLayout;
    public isDateRange:boolean;
    public DateFrom ="";
  public DateTo ="";
  public dateValue ="all";
  public roleId = '3';
  public loading = true;
  users = [{
    id: 3, name: 'All'},
  {
    id: 1, name: 'Caregiver'},
  {
    id: 2, name: 'Agency Rep'},
  ];
 
     rowData =[];
    ngOnInit(): void {
        
//           const utcTimestamp = "2021-06-22T12:03:43.000+0000";
// const date = new Date(utcTimestamp);

// // Automatically convert to the user's local timezone
// const localTime = this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    }
    constructor(
        private userService:UserService,
      ){
        this.paginationPageSize =10;
        this.domLayout = 'autoHeight';
        this.userService.caregiverHistory().subscribe((res:any)=>{
          this.rowData = res.caregiverHistory;
          this.loading = false
        })
      }
    columnDefs = [{headerName:"Document Id", field: "caregiverDocId", sortable:true, unSortIcon: true, filter:true,resizable: true},
      {headerName:"Document Name", field: "documentName", sortable: true, unSortIcon: true, filter:true, resizable: true}, 
      {headerName:"Document Type", field: "documentType", sortable: true, unSortIcon: true, filter:true, resizable: true},
      {headerName:"Shared To/Requested By", field: "requestedBy", sortable: true, unSortIcon: true, filter:true, resizable: true},  
  {headerName:"Date/Time", field: "activityTime", sortable: true, resizable: true,valueFormatter:this.dateformatter,
  filter: 'agDateColumnFilter',
    filterParams:{
      comparator: (filterLocalDateAtMidnight, cellValue)=> {
        var dateAsString = this.dateformatter(cellValue);
        if (dateAsString == null) return 0;
        var dateParts = dateAsString.split('/');
        const day = Number(dateParts[1]);
        const month = Number(dateParts[0]) - 1;
        const year = Number(dateParts[2]);
        var cellDate = new Date(year, month, day);
        console.log("cellDate", cellDate);
       if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        } else if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        } else {
          return 0;
        }
      }},},
  {headerName:"IsDownloaded", field: "isDownloaded",filter:true, sortable: true, resizable: true}
];

dateformatter(params){ /** for date format */
var dateSplit;
if(params.value !=null && params.value !=undefined){
 // dateSplit = params.value.split("T");
  var convertedDate = new Date(params.value);
  dateSplit = params.value.split("T");

  // else{
  //   dateSplit = params.split("T");
  // }
   // var dateSplit = params.value.split("T");
    var dateSplit1 = dateSplit[0].split("-");
    var date = dateSplit1[2];
    var month = dateSplit1[1];
    var year = dateSplit1[0];
    //return fullDate;

// else{
//   dateSplit = params.split("T");
// }
 // var dateSplit = params.value.split("T");
  
  var hour = convertedDate.getHours();
  var minutes = convertedDate.getMinutes();
  var shift ="AM";
  if(hour>=12 && hour<24){
    shift = "PM";
    hour -= 12;
  }
  var formattedHour = hour.toString().padStart(2, '0');
  var formattedMinutes = minutes.toString().padStart(2, '0');
  var fullDate = month.concat("/", date, "/", year)+ " "+formattedHour+":"+formattedMinutes+" "+shift;
  return fullDate;
}
 // return moment(params.value).format('DD/MM/YYYY'); 
}
gridOptions: GridOptions = {
  defaultColDef: {
    // sortable: true,
    // filter: true,
    // resizable: true,
    menuTabs: ['filterMenuTab'], // Show only the filter menu
  },
  icons: {
    menu: '<i class="fa fa-search"></i>', // Replace menu icon with a search icon
  },
}
  onGridReady(params) {  /** for recruiter table */
    
    // params.api.sizeColumnsToFit();
    if(window.matchMedia("(min-width: 1260px)").matches){
     params.api.sizeColumnsToFit();
   }
     window.addEventListener("resize", function () {
       setTimeout(function () {
         if(window.matchMedia("(min-width: 1260px)").matches){
         params.api.sizeColumnsToFit();
       }
       });
     });
   
   this.gridApi = params;
   this.gridApi.api.setColumnDefs(this.columnDefs);
   this.gridApi.api.setRowData(this.rowData); 
   //this.autoSizeAll();
  
  // this.gridApi.setDomLayout('autoHeight');
   //document.getElementById('#myGrid').style.height = '';
 }
}